import React from 'react';
import Stacy from '../../assets/img/person1.jpg';
import Alicia from '../../assets/img/person2.jpg';
import Kimberly from '../../assets/img/person3.jpg';

const Testimonials = () => {
	return (
		<section class='cta-bg py-5'>
			<div class='container'>
				<div class='slider-item active-slider-item'>
					<div class='row'>
						<div class='col-md-8'>
							<h2 class='cta_title'>
								This is what <span>Stacy</span> thinks
							</h2>
							<p>
								<i class='fa fa-quote-left mr-2' aria-hidden='true'></i>
								Lorem ipsum dolor sit amet consectetur, adipisicing
								elit. Fugiat eius consequuntur mollitia recusandae!
								Rerum sit voluptas sapiente esse quo accusamus, ab
								nesciunt vitae velit repellat, architecto voluptates.
								Commodi, labore in.
								<i
									class='fa fa-quote-right ml-2'
									aria-hidden='true'
								></i>
							</p>
						</div>
						<div class='col-md-4'>
							<img src={Stacy} class='img-fluid rounded-circle' alt='' />
						</div>
					</div>
				</div>
				<div class='slider-item'>
					<div class='row'>
						<div class='col-md-8'>
							<h2 class='cta_title'>
								This is what <span>Alicia</span> thinks
							</h2>
							<p>
								<i class='fa fa-quote-left mr-2' aria-hidden='true'></i>
								Lorem ipsum dolor sit amet consectetur, adipisicing
								elit. Fugiat eius consequuntur mollitia recusandae!
								Rerum sit voluptas sapiente esse quo accusamus, ab
								nesciunt vitae velit repellat, architecto voluptates.
								Commodi, labore in.
								<i
									class='fa fa-quote-right ml-2'
									aria-hidden='true'
								></i>
							</p>
						</div>
						<div class='col-md-4'>
							<img
								src={Alicia}
								class='img-fluid rounded-circle'
								alt=''
							/>
						</div>
					</div>
				</div>
				<div class='slider-item'>
					<div class='row'>
						<div class='col-md-8'>
							<h2 class='cta_title'>
								This is what <span>Kimberly</span> thinks
							</h2>
							<p>
								<i class='fa fa-quote-left mr-2' aria-hidden='true'></i>
								Lorem ipsum dolor sit amet consectetur, adipisicing
								elit. Fugiat eius consequuntur mollitia recusandae!
								Rerum sit voluptas sapiente esse quo accusamus, ab
								nesciunt vitae velit repellat, architecto voluptates.
								Commodi, labore in.
								<i
									class='fa fa-quote-right ml-2'
									aria-hidden='true'
								></i>
							</p>
						</div>
						<div class='col-md-4'>
							<img
								src={Kimberly}
								class='img-fluid rounded-circle'
								alt=''
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Testimonials;
